import styles from './EnrollNowButton.module.scss';
import { IModalActions, ModalTypes } from '@/types/modal';

import { useModalDispatch } from "@/context/ModalContext";
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue } from '@/context/utils';
import { usePathname } from 'next/navigation';

const LANDING_PAGE_VALUE = {
  "/lp-nw-amity-ug": "UG",
  "/lp-nw-amity-pg": "PG"
};

export default function EnrollNowButton({ associatedPrograms }) {
  const modalDispatch = useModalDispatch();

  const path = usePathname();
  const isAfricaPage = path == "/africa" || path == "/isat"
  const landingPageValue = LANDING_PAGE_VALUE[path] || "";
  const isAccaPage = path === "/lp-nw/acca";

  if(isAfricaPage){
    return null;
  }

  const applyNowCTA = () => { 
    const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
    const specializationText = associatedPrograms[0]?.attributes?.BasicDetails?.SpecializationText || '';
    const brochure =  associatedPrograms[0]?.attributes?.BasicDetails?.Brochure?.data?.attributes?.url || '';
    const programDetails = associatedPrograms[0]?.attributes?.BasicDetails
    
   
    modalDispatch ({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.LandingPageConnectModalTempleteOne,
        modalData: { specializationText, Custom10PgType, brochure, isMobile: true, programDetails, associatedPrograms, isLandingPage: true, landingPageValue, isLambdaAPI: isAccaPage },
      }}
    );



    pushToDataLayer({
      event: "lead_initiate",
      cta_text: 'Apply now',
      section_name: "Bottom Navigation Bar",
      header_title: "NA",
      page_type: getGlobalStateValue('pageType')
    });


    window?.webengage?.track("Enquire Now Clicked");

  }

  return (
    <div className={styles.enrollCTAContainer} id="enroll-now-button-cta" >
        <div onClick={applyNowCTA} className={styles.enrollCTAContainerInner}>Enquire now &#8594;</div>
    </div>
  )
}
